import { render, staticRenderFns } from "./PolizasSAResponse.vue?vue&type=template&id=3d6e8736&scoped=true&"
import script from "./PolizasSAResponse.vue?vue&type=script&lang=js&"
export * from "./PolizasSAResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6e8736",
  null
  
)

export default component.exports